<template>
    <div id="homeBox">
        <div class="flex mrt20">
            <el-table
                    size="mini"
                    ref="topdeliverlight"
                    class="mrt5"
                    :data="topData"
                    style="width: 100%"
                    :height="toptableHeight"
                    :highlight-current-row="highlightCurrentRow"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    @row-click="rowclick"
            >
                <el-table-column
                        prop="vc_gsname"
                        label="公司名称"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_jstime"
                        label="结转时间"
                        width="140"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        label="操作时间"
                        width="140"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_lruname"
                        label="操作人"
                        width="140"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="120">
                    <template slot-scope="scope">
                        <!--<el-button  type="text" size="small" @click.native.stop="carrynow(scope.row)"  disabled >本月结转</el-button>-->
                        <el-button  type="text" size="small" @click.native.stop="carrynext(scope.row)" :disabled="scope.row.i_state==1?false:true" >结转次月</el-button>
                        <el-button  type="text" size="small" @click.native.stop="over(scope.row)" :disabled="overdis" >完结</el-button>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-table
                :data="tableData"
                ref="deliverlight"
                :height="tableHeight"
                style="width: 100%">
            <el-table-column
                    prop="date"
                    label="原辅料">
                <template  slot-scope="scope">
                    <el-progress  :percentage="percentagetable" :stroke-width="20" :text-inside="true" status="success"></el-progress>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="200">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" :disabled="tablestar" @click="star(0)" v-if="percentagetable==0">开始</el-button>
                    <el-button  type="text" size="small" :disabled="tablecont" @click="cont" v-if="percentagetable>0&&percentagetable<100">继续</el-button>
                    <el-button  type="text" size="small" :disabled="tableretu" @click="retun" v-if="percentagetable==100">重新结转</el-button>
                    <el-button  type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--<el-table
                :data="selttleData"
                ref="deliverlight"
                :height="tableHeight"
                style="width: 100%">
            <el-table-column
                    prop="date"
                    label="结算单">
                <template  slot-scope="scope">
                    <el-progress  :percentage="percentageselttle" :stroke-width="20" :text-inside="true" status="success"></el-progress>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="200">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" :disabled="selttlestar" @click="star(1)" v-if="percentageselttle==0">开始</el-button>
                    <el-button  type="text" size="small" :disabled="selttlecont" @click="selcont" v-if="percentageselttle>0&&percentageselttle<100">继续</el-button>
                    <el-button  type="text" size="small" :disabled="selttleretu" @click="selretun" v-if="percentageselttle==100">重新结转</el-button>
                    <el-button  type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-table
                :data="finishData"
                ref="deliverlight"
                :height="tableHeight"
                style="width: 100%">
            <el-table-column
                    prop="date"
                    :label="$t('form_finished_goods')">
                <template  slot-scope="scope">
                    <el-progress  :percentage="percentagefinish" :stroke-width="20" :text-inside="true" status="success"></el-progress>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="200">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" :disabled="finishstar" @click="star(1)" v-if="percentagefinish==0">开始</el-button>
                    <el-button  type="text" size="small" :disabled="finishcont" @click="concont" v-if="percentagefinish>0&&percentagefinish<100">继续</el-button>
                    <el-button  type="text" size="small" :disabled="finishretu" @click="conretun" v-if="percentagefinish==100">重新结转</el-button>
                    <el-button  type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--<div style="position: relative">
            <div v-show="prograss">
                <el-table
                        :data="tableData"
                        ref="deliverlight"
                        :height="tableHeight"
                        style="width: 100%">
                    <el-table-column
                            prop="date"
                            label="原辅料">
                        <template  slot-scope="scope">
                            <el-progress  :percentage="percentagetable" :stroke-width="20" :text-inside="true" status="success"></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="200">
                        <template slot-scope="scope">
                            <el-button  type="text" size="small" :disabled="tablestar" @click="star">开始</el-button>
                            <el-button  type="text" size="small" :disabled="tableretu" @click="retun">重新结转</el-button>
                            <el-button  type="text" size="small" :disabled="tablecont" @click="cont">继续</el-button>
                            <el-button  type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table
                        :data="selttleData"
                        ref="deliverlight"
                        :height="tableHeight"
                        style="width: 100%">
                    <el-table-column
                            prop="date"
                            label="结算单">
                        <template  slot-scope="scope">
                            <el-progress  :percentage="percentageselttle" :stroke-width="20" :text-inside="true" status="success"></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="200">
                        <template slot-scope="scope">
                            <el-button  type="text" size="small" :disabled="selttlestar" @click="selstar">开始</el-button>
                            <el-button  type="text" size="small" :disabled="selttleretu" @click="selretun">重新结转</el-button>
                            <el-button  type="text" size="small" :disabled="selttlecont" @click="selcont">继续</el-button>
                            <el-button  type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table
                        :data="finishData"
                        ref="deliverlight"
                        :height="tableHeight"
                        style="width: 100%">
                    <el-table-column
                            prop="date"
                            label="产成品">
                        <template  slot-scope="scope">
                            <el-progress  :percentage="percentagefinish" :stroke-width="20" :text-inside="true" status="success"></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="200">
                        <template slot-scope="scope">
                            <el-button  type="text" size="small" :disabled="finishstar" @click="constar">开始</el-button>
                            <el-button  type="text" size="small" :disabled="finishretu" @click="conretun">重新结转</el-button>
                            <el-button  type="text" size="small" :disabled="finishcont" @click="concont">继续</el-button>
                            <el-button  type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-show="text" style="width:100px; margin:0 5px 0 5px;border:3px solid red;position: absolute;top:170px;left: 400px ">
                <span style="color:red; font-size:15pt;">当前无数据 请新增结转</span>
            </div>
        </div>-->
        <!--确认dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    class="dia"
                    width="30%"
                    :title="sureTitle"
                    :visible.sync="checkdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="checkdialogVisible">
                <p>是否确认？</p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini"   @click="checkdialogVisible = false">取消</el-button>
                    <el-button type="primary" :class="baseerp+'btn'" size="mini" :disabled="visible" @click="sureit">确认</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import{sse_url} from '@/utils/baseUrl';
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";



    export default {
        name: "CostSettlement",
        components: {},
        props:{

        },
        data() {
            return {
                overdis:false,
                vc_lruname:"",
                precentData:[],
                allData:[],
                /*starDa_total:0,
                settDa_total:0,
                proDa_total:0,
                starDa_num:0,
                settDa_num:0,
                proDa_num:0,*/
                type:2,
                JzNum:0,
                JzTotal:0,
                sureTitle:"",
                ty_pe:"",
                carrynextDis:false,
                visible:false,
                checkdialogVisible:false,
                i_id:0,
                addmonth:0,
                dt_jstime:"",
                text:false,
                prograss:false,
                highlightCurrentRow:true,
                topData:[/*{i_id:1,dt_jstime:1,i_state:1},
                        {i_id:2,dt_jstime:1,i_state:null}*/],
                uuid:"",
                timestamp:"",
                percentagefinish:0,
                percentageselttle:0,
                percentagetable:0,
                finishcont:false,
                finishretu:false,
                finishstar:false,
                selttlecont:false,
                selttleretu:false,
                selttlestar:false,
                tablecont:false,
                tableretu:false,
                tablestar:false,
                tableHeight:0,
                toptableHeight:0,
                i_state:0,
                finishData:[{date:1}],
                selttleData:[{date:1}],
                tableData:[{date:1}],
                defaultValue:"",
                companyName:[],
                gsid:0,
                gsname:"",
                baseerp: "",
                file_url: "",
                baseApp:"",
                baseVersion:"",
                token:"",
                i_uid:"",
            }
        },
        watch: {
            //默认一进页面选中第一行
            topData: function() {
                this.$nextTick(function() {
                    this.$refs.topdeliverlight.setCurrentRow(this.topData[0]);
                    this.rowclick(this.topData[0]);
                })
            },

            percentagefinish:{
                handler(){
                    //console.log(this.percentagefinish,"watch3");
                },
                immediate:true,
                deep:true
            },
            percentageselttle:{
                handler(){
                    //console.log(this.percentageselttle,"watch2");
                    if (this.percentageselttle==0){
                        this.finishcont=false;
                        this.finishretu=false;
                               this.finishstar=true;//
                        this.selttlecont=false;
                        this.selttleretu=false;
                        this.selttlestar=false;
                        this.tablecont=false;
                        this.tableretu=false;
                        this.tablestar=false;
                        //console.log(this.finishstar,"finishstar1");
                    }else if(this.percentageselttle>0&&this.percentageselttle<100){
                        this.finishcont=false;
                        this.finishretu=false;
                                this.finishstar=true;//
                        this.selttlecont=false;
                        this.selttleretu=false;
                        this.selttlestar=false;
                        this.tablecont=false;
                        this.tableretu=false;
                        this.tablestar=false;
                        //console.log(this.finishstar,"finishstar2");
                    }else if(this.percentageselttle==100){
                        this.finishcont=false;
                        this.finishretu=false;
                                this.finishstar=false;//
                        this.selttlecont=false;
                        this.selttleretu=false;
                        this.selttlestar=false;
                        this.tablecont=false;
                        this.tableretu=false;
                        this.tablestar=false;
                        //console.log(this.finishstar,"finishstar3");
                    }
                },
                immediate:true,
                deep:true
            },
            percentagetable:{
                handler(){
                    //console.log(this.percentagetable,"watch1");
                    if (this.percentagetable==0){
                       this.finishcont=false;
                       this.finishretu=false;
                                this.finishstar=true;//
                       /*this.selttlecont=false;
                       this.selttleretu=false;
                       this.selttlestar=true;//*/
                       this.tablecont=false;
                       this.tableretu=false;
                       this.tablestar=false;
                        //console.log(this.finishstar,"finishstar4");
                    }else if(this.percentagetable>0&&this.percentagetable<100){
                        this.finishcont=false;
                        this.finishretu=false;
                                this.finishstar=true;//
                        /*this.selttlecont=false;
                        this.selttleretu=false;
                        this.selttlestar=true;//*/
                        this.tablecont=false;
                        this.tableretu=false;
                        this.tablestar=false;
                        //console.log(this.finishstar,"finishstar5");
                    }else if(this.percentagetable==100){

                        this.finishcont=false;
                        this.finishretu=false;
                                this.finishstar=false;//
                        /*this.selttlecont=false;
                        this.selttleretu=false;
                        this.selttlestar=false;//*/
                        this.tablecont=false;
                        this.tableretu=false;
                        this.tablestar=false;
                        //console.log(this.finishstar,"finishstar6");
                    }
                },
                immediate:true,
                deep:true
            },

        },
        /*watch:{
            tabslist(){
                if (this.tabslist){
                    this.i_type=this.tabslist.i_type;
                    this.i_show=this.tabslist.i_show;
                    this.formvalue=this.tabslist;
                    // console.log(this.formvalue,"this.formvalue");

                }
            },
            immediate:true,
            deep:true
        },*/
        mounted() {
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            this.uuid=sessionStorage.getItem('uuid');
            //console.log(this.uuid,"uuid");


            this.$nextTick(function () {
                this.onResize();

            });

            //拿到时间戳
            this.timestamp = (new Date()).valueOf();
            //console.log(this.timestamp,"timestamp");

            //SSE连接
            this.sse_fun();



            ///一进页面调topData接口
            this.getCbJsList();




        },
        watch:{

            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-400
                this.toptableHeight=n.h-300
                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.deliverlight.$el.clientTop - 770;
                this.toptableHeight = window.innerHeight - this.$refs.topdeliverlight.$el.clientTop - 670;
            },
            ...mapActions(["getCurrentMenuId"]),

            over(row){
                // console.log(row,"完结row");
                this.vc_lruname=row.vc_lruname;
                this.dt_jstime=row.dt_jstime;
                this.gsid=row.i_gsid;
                this.i_id=row.i_id;
                this.sureTitle="完结";
                this.checkdialogVisible=true;

            },

            //完结
            async carryOverEnd(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.dt_jstime,
                    i_id:this.i_id,
                    vc_lruname:this.vc_lruname,
                    /*i_flag:this.i_flag,
                    type:this.type,
                    userId:this.timestamp,*/
                };
                //console.log(param,"param");
                let res=await API.carryOverEnd(param);
                if(res.code==1){
                    this.finishcont=true;
                    this.finishretu=true;
                    this.finishstar=true;//
                    this.tablecont=true;
                    this.tableretu=true;
                    this.tablestar=true;
                    this.$message.success(res.message);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            sse_fun(){
                let that=this;
                var MESSAGR_URL=sse_url+"/"+"connect"+"/"+this.timestamp+"/"+this.uuid;
                var source= new EventSource(MESSAGR_URL);
                source.onopen=function (e) {
                    //console.log(e);
                };
                source.onmessage=function (e) {
                    //console.log(e.data,"message");
                    //console.log(e.data.jznum,"jznum")
                    var message=JSON.parse(e.data );
                    //console.log(message,"message");
                    that.ty_pe="";
                    if (message!=undefined&&message!=""){
                        that.ty_pe=message.type==undefined?"":message.type;
                        //console.log(that.ty_pe,"this.ty_pe");
                        if (that.ty_pe!='test'){
                            that.JzNum=message.jznum;
                            that.JzTotal=message.jztotal;
                            //console.log(that.JzNum,"jznum");
                            //console.log(that.JzTotal,"jztotal");
                            //console.log(that.type,"type");
                            if (that.type==1){
                                that.percentagetable=Math.round((message.jznum/message.jztotal)*100);
                                //console.log(that.percentagetable,"percentagetable_sse");
                                /*if (that.percentagetable==100){
                                    that.selttlestar=false;
                                    that.finishstar=true;
                                }*/

                            }else if (that.type==2){
                                that.percentagefinish=Math.round((message.jznum/message.jztotal)*100);
                                //console.log(that.percentagefinish,"percentagefinish_sse");


                            }
                            /*if (that.type==1){
                                that.percentagetable=((message.jznum/message.jztotal)*100);
                                console.log(that.percentagetable,"percentagetable_sse");
                                /!*if (that.percentagetable==100){
                                    that.selttlestar=false;
                                    that.finishstar=true;
                                }*!/

                            }else if (that.type==2){
                                that.percentageselttle=((message.jznum/message.jztotal)*100);
                                console.log(that.percentageselttle,"percentageselttle_sse");
                                /!*if (that.percentageselttle==100){
                                    that.finishstar=false;
                                }*!/

                            }else if(that.type==3){
                                that.percentagefinish=((message.jznum/message.jztotal)*100);
                                console.log(that.percentagefinish,"percentagefinish_sse");
                            }*/
                        }
                    }
                };
            },

            sureit(){
                if (this.sureTitle=="结转次月"){
                    this.checkdialogVisible=false;
                    this.saveCarryOver();
                    //console.log("结转次月")
                }else if (this.sureTitle=="重新结转原辅料"){
                    this.i_flag=2;
                    this.type=1;
                    this.percentagefinish=0;
                    this.percentageselttle=0;
                    this.percentagetable=0;
                    /*this.starDa_num=0;
                    this.settDa_num=0;
                    this.proDa_num=0;*/

                    /*this.finishstar=true;
                    this.selttlestar=true;*/

                    this.carryOver();
                    this.checkdialogVisible=false;
                    //console.log("结转原辅料")
                }else if (this.sureTitle=="重新结转结算单"){
                    /*this.i_flag=2;
                    this.type=2;
                    this.percentagefinish=0;
                    this.percentageselttle=0;
                    /!*this.settDa_num=0;
                    this.proDa_num=0;*!/

                    /!*this.finishstar=true;*!/

                    this.carryOver();
                    this.checkdialogVisible=false;
                    console.log("结转结算单")*/
                }else if (this.sureTitle=="重新结转产成品"){
                    this.i_flag=2;
                    //this.type=3;
                    this.type=2;
                    this.percentagefinish=0;
                    /*this.proDa_num=0;*/
                    this.carryOver();
                    this.checkdialogVisible=false;
                    //console.log("结转产成品")
                }else if (this.sureTitle=="完结"){
                    /*this.finishcont=true;
                    this.finishretu=true;
                    this.finishstar=true;//
                    this.tablecont=true;
                    this.tableretu=true;
                    this.tablestar=true;*/
                    this.carryOverEnd();
                    this.checkdialogVisible=false;
                }


            },

            cancelDialog(){
                this.checkdialogVisible=false;
            },

            carrynow(row){
                ///进度框显示 调保存接口 在回调调carryoverList 在carry的回调里重新触发rowclick
               //console.log(row,"carrynow");
               this.gsid=row.i_gsid;
               this.dt_jstime=row.dt_jstime;
               this.addmonth=0;
               this.prograss=true;
               this.text=false;
               this.i_id=row.i_id;
               this.i_state=row.i_state;
               this.saveCarryOver();
               //console.log(this.prograss,"显示")
            },

            carrynext(row){
                this.sureTitle="结转次月";
                this.checkdialogVisible=true;
                ///进度框显示 调保存接口 在回调调carryoverList 在carry的回调里重新触发rowclick
                //console.log(row,"carrynext");
                this.gsid=row.i_gsid;
                this.dt_jstime=row.dt_jstime;
                this.addmonth=1;
                this.prograss=true;
                this.text=false;
                this.i_id=row.i_id;
                this.i_state=row.i_state;
                //this.saveCarryOver();
                //console.log(this.prograss,"显示")
            },

            rowclick(row){
                //console.log(row,"row");
                this.i_id=row.i_id;
                this.i_state=row.i_state;
                this.gsid=row.i_gsid;
                this.dt_jstime=row.dt_jstime;
                //调获取进度条列表接口
                this.getCarryOverList();
            },

            concont(){
                this.i_flag=3;
                //this.type=3;
                this.type=2;
                this.carryOver();
            },

            conretun(){
                this.sureTitle="重新结转产成品";
                this.checkdialogVisible=true;

            },

            constar(){
                this.i_flag=1;
                this.type=3;
                this.carryOver();
            },

            selcont(){
                this.i_flag=3;
                this.type=2;
                this.carryOver();
            },

            selretun(){
                this.sureTitle="重新结转结算单";
                this.checkdialogVisible=true;

            },

            selstar(){
                this.i_flag=1;
                this.type=2;
                this.carryOver();
            },



            //结转
            async carryOver(){
                //console.log(this.i_flag,this.type,this.dt_jstime,this.gsid,this.timestamp,"carryover1");
                let param={
                    i_mid: this.mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.dt_jstime,
                    i_flag:this.i_flag,
                    type:this.type,
                    userId:this.timestamp,
                };
                let res=await API.carryOver(param);
                if(res.code==1){
                    if (this.type==1){
                        this.tablestar=false;
                    }else if (this.type==2){
                        this.finishstar=false;
                    }
                    /*if (this.type==1){
                        this.tablestar=false;
                    }else if (this.type==2){
                        this.selttlestar=false;
                    }else if(this.type==3){
                        this.finishstar=false;
                    }*/
                    //console.log(this.tablestar,this.selttlestar,this.finishstar,"star");
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            cont(){
                this.i_flag=3;
                this.type=1;
                this.carryOver();
            },

            showPercentage(js_type){
                //console.log(this.precentData,"js",this.precentData[js_type]);
                return this.precentData[js_type];


            },


            star(js_type){
                //console.log(js_type,"js_type");
                //console.log(this.allData,"allData");
                if (this.allData[js_type].total==0){
                    //this.precentData[js_type]=100;
                    if (js_type==0)this.percentagetable=100;
                    //if (js_type==1)this.percentageselttle=100;
                    if (js_type==1)this.percentagefinish=100;
                }else{
                    this.i_flag=1;
                    this.type=js_type+1;
                    if (js_type==0){
                        this.tablestar=true;
                    }else if (js_type==1){
                        //this.selttlestar=true;
                        this.finishstar=true;
                    }
                    /*else if(js_type==2){
                        this.finishstar=true;
                    }*/
                    //console.log(this.tablestar,this.selttlestar,this.finishstar,"star");
                    this.carryOver();
                    /*if (js_type==0){
                        this.i_flag=1;
                        this.type=1;
                        this.carryOver();
                    }else if (js_type==1){
                        this.i_flag=1;
                        this.type=2;
                        this.carryOver();
                    }else if (js_type==2){
                        this.i_flag=1;
                        this.type=3;
                        this.carryOver();
                    }*/
                }

                /*this.i_flag=1;
                this.type=1;
                this.carryOver();*/
                /*//console.log(this.percentagetable,"percentagetable");
                for (let i=0;i<=100;i++){
                    this.percentagetable=i;
                    //console.log(this.percentagetable,"percentagetable");
                }
                if (this.percentagetable==100){
                    this.tablestar=true;
                }*/
            },

            retun(){
                this.sureTitle="重新结转原辅料";
                this.checkdialogVisible=true;


                /*this.percentagetable=0;
                console.log(this.percentagetable,"percentagetable");
                this.tablestar=false;*/
            },

            //公司列表
            async getCbJsList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid:this.mid,
                };
                let res=await API.getCbJsList(param);
                if(res.code==1){
                    this.topData=res.data;
                    //console.log(this.topData,"topData");
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //保存列表
            async saveCarryOver(){
                let param={
                    i_mid:this.i_mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.dt_jstime,
                    addmonth:this.addmonth,
                };
                let res=await API.saveCarryOver(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.getCbJsList();
                    this.getCarryOverList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //公司接口
            /*async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid: this.mid,
                    i_type:"1,2,0",
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.companyName=res.data;
                        //this.formData.gsname=this.companyName[0].vc_name;
                        this.gsname=this.companyName[0].vc_name;
                        this.gsid=this.companyName[0].i_id;
                        this.getCbJsTime();
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },*/

            /*changeCompany(val){
                // console.log("--gsis",val);
                /!*if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }*!/
                this.gsid=val;
                this.getCbJsTime();
                //this.getJsTime();
                /!*if (val??''!==''){
                    let obj = this.companyName.find(item => item.i_id == val);
                    this.gsname = obj.vc_name;
                }else {
                    this.gsname='';
                }*!/
            },*/

            //获取未结转时间
           /* async getCbJsTime(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.gsid,
                };
                let res=await API.getCbJsTime(param);
                if(res.code==1){
                    this.defaultValue=res.data.dt_jstime;
                    this.i_state=res.data.i_state;
                    console.log("this.defaultValue111",this.defaultValue,'i_state',this.i_state);
                    //禁用判断
                    /!*if (this.i_state==0){
                        this.tablestar=true;
                        this.tablecont=true;
                        this.tableretu=true;
                        this.finishcont=true;
                        this.finishretu=true;
                        this.finishstar=true;
                        this.selttlecont=true;
                        this.selttleretu=true;
                        this.selttlestar=true;
                        this.percentagefinish=100;
                        this.percentageselttle=100;
                        this.percentagetable=100;
                    }else if (this.i_state==1){
                            this.tablestar=false;
                        this.tablecont=true;
                        this.tableretu=true;
                        this.finishcont=true;
                        this.finishretu=true;
                        this.finishstar=true;
                        this.selttlecont=true;
                        this.selttleretu=true;
                        this.selttlestar=true;
                        this.percentagefinish=0;
                        this.percentageselttle=0;
                        this.percentagetable=0;
                        ///调接口拿到做禁用判断的状态
                    }*!/
                    //this.getCarryOverList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },*/


            //获取进度条列表
            async getCarryOverList(){
                //console.log(this.i_id,this.i_state,"从row拿");
                let param = {
                    i_mid:this.mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.dt_jstime,
                    i_id:this.i_id,
                    //i_state:this.i_state,
                };
                let res = await API.getCarryOverList(param);
                if (res.code == 1) {
                    //console.log(res.data,"获取进度条数据");
                    this.allData=res.data;
                    //进度条数据处理
                    let starDa=res.data[0];
                    //let settDa=res.data[1];
                    let proDa=res.data[1];
                   /* this.starDa_num=res.data[0].num;
                    this.settDa_num=res.data[1].num;
                    this.proDa_num=res.data[2].num;*/
                    this.starDa_total=res.data[0].total;
                    //this.settDa_total=res.data[1].total;
                    this.proDa_total=res.data[1].total;
                    //console.log(starDa,settDa,proDa,"data");
                    //console.log(this.starDa_num,this.settDa_num,this.proDa_num,"num");
                    if (starDa.total==0){
                        //console.log(starDa.total,"starDa.total");
                        this.percentagetable=0;
                    }else{
                        //console.log(starDa.total,"starDa.total");
                        this.percentagetable=Math.round((starDa.num/starDa.total)*100);

                    };
                    /*if (settDa.total==0){
                        //console.log(settDa.total,"settDa.total");
                        this.percentageselttle=0;
                    }else{
                        //console.log(settDa.total,"settDa.total");
                        this.percentageselttle=Math.round((settDa.num/settDa.total)*100);
                    };*/
                    if (proDa.total==0){
                        //console.log(proDa.total,"proDa.total");
                        this.percentagefinish=0;
                    }else{
                        //console.log(proDa.total,"proDa.total");
                        this.percentagefinish=Math.round((proDa.num/proDa.total)*100);
                    };
                    //console.log(this.percentagetable,this.percentageselttle,this.percentagefinish,"%%%%");

                    //overdis
                    if (this.percentagetable==100&&this.percentagefinish==100){
                        this.overdis=false;
                        //console.log(this.overdis,"this.overdis1")
                    }else{
                        this.overdis=true;
                        //console.log(this.overdis,"this.overdis2")
                    }

                    /*//按钮控制
                    if (this.percentagetable==100){
                        this.finishstar=true;
                        this.selttlestar=false;
                    }else{
                        this.finishstar=true;
                        this.selttlestar=true;
                    };

                    if (this.percentageselttle==100){
                        this.finishstar=false;
                    }else {
                        this.finishstar=true;
                    };*/
                    //this.finishcont=false;
                    //this.finishretu=false;
                    //this.finishstar=false;
                    //this.selttlecont=false;
                    //this.selttleretu=false;
                    //this.selttlestar=false;
                    //this.tablecont=false;
                    //this.tableretu=false;
                    //this.tablestar=false;
                    /*                    if (res.data!=""){
                        //禁用判断
                        let iState=res.data.i_state;
                        if (iState==0){
                            console.log(iState,"iState");
                            this.tablestar=false;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==31||iState==-11){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=false;
                            this.tableretu=false;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==11){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=false;

                        }else if (iState==32||iState==-12){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=false;
                            this.selttleretu=false;
                            this.selttlestar=true;

                        }else if (iState==12){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=false;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==33||iState==-13){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=false;
                            this.finishretu=false;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==1){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=false;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;
                        }
                        //进度条数据处理
                        let starDa=res.data.details[0];
                        let settDa=res.data.details[1];
                        let proDa=res.data.details[2];
                        console.log(starDa,settDa,proDa,"data");
                        this.percentagetable=(starDa.num/starDa.total)*100;
                        this.percentageselttle=(settDa.num/settDa.total)*100;
                        this.percentagefinish=(proDa.num/proDa.total)*100;
                        console.log(this.percentagetable,this.percentageselttle,this.percentagefinish,"%%%%");

                    }else if (res.data==""){
                        //禁用判断
                        this.tablestar=false;
                        this.tablecont=true;
                        this.tableretu=true;
                        this.finishcont=true;
                        this.finishretu=true;
                        this.finishstar=true;
                        this.selttlecont=true;
                        this.selttleretu=true;
                        this.selttlestar=true;
                        //进度条数据处理
                        this.percentagetable=0;
                        this.percentageselttle=0;
                        this.percentagefinish=0;
                    }*/
                    ///做控制--有数据 进度框显示；无数据 文字框显示（pass）
                    /*if (res.data==""){
                        console.log(res.data,"11111111111");
                        this.prograss=false;
                        this.text=true;
                    }else{
                        console.log(res.data,"2222222222");
                        this.prograss=true;
                        this.text=false;
                        //禁用判断
                        let iState=res.data.i_state;
                        if (iState==0){
                            console.log(iState,"iState");
                            this.tablestar=false;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==31||iState==-11){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=false;
                            this.tableretu=false;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==11){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=false;

                        }else if (iState==32||iState==-12){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=true;
                            this.selttlecont=false;
                            this.selttleretu=false;
                            this.selttlestar=true;

                        }else if (iState==12){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=true;
                            this.finishstar=false;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==33||iState==-13){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=false;
                            this.finishretu=false;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;

                        }else if (iState==1){
                            console.log(iState,"iState");
                            this.tablestar=true;
                            this.tablecont=true;
                            this.tableretu=true;
                            this.finishcont=true;
                            this.finishretu=false;
                            this.finishstar=true;
                            this.selttlecont=true;
                            this.selttleretu=true;
                            this.selttlestar=true;
                        }
                        //进度条数据处理
                        let starDa=res.data.details[0];
                        let settDa=res.data.details[1];
                        let proDa=res.data.details[2];
                        console.log(starDa,settDa,proDa,"data");
                        this.percentagetable=(starDa.num/starDa.total)*100;
                        this.percentageselttle=(starDa.num/starDa.total)*100;
                        this.percentagefinish=(starDa.num/starDa.total)*100;
                        console.log(this.percentagetable,this.percentageselttle,this.percentagefinish,"%%%%");
                    }*/
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //关闭SSE接口
            async closeSSE(){
                let param={
                    userId:this.timestamp+'',
                };
                let res=await API.closeSSE(param);
                if(res.code==1){
                    //this.$message.success(res.message);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //获取当月日期
           /* getDateMonth(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                //this.defaultValue=`${date.getFullYear()}-${month}`;
                this.dataTime=`${date.getFullYear()}${month}${strDate}`;
                console.log(this.dataTime,"this.dataTime")
                // console.log(this.defaultValue,"defaultValue")
            },*/


        },

        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto);

            //调关闭SSE接口
            this.closeSSE();
        },
    }
</script>

<style lang="scss" scoped>

    .mrl5{
        margin-left: 5px;
    }
    .mrt20{
        margin-top: 20px;
    }

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
    }
    /deep/{

        .el-table--striped .el-table__body tr.el-table__row--striped.current-row td, .el-table__body tr.current-row>td {
            color: #fff;
            background-color: #a2a4a7!important;
        }

        .el-progress-bar__innerText{
           color: #4a4a4a;
        }
        .el-table td, .el-table th.is-leaf {
            border-bottom:none;
        }

        .el-tabs__item{
            height: 32px;
            line-height: 32px;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev{
            line-height: 32px;
        }
    }

</style>